<template>
    <div class="empty-container" :style="{'margin-top':marginTopStyle}">
        <img :src="emptyImg|default_img" alt="" />
        <div v-if="showText" class="empty-text">{{ emptyText }}</div>
        <div v-if="showTips" class="empty-tips">{{ emptyTips }}</div>
        <div v-if="showBtn" class="bottom-btn" @click="onBtnClick">{{ bottomBtn }}</div>
    </div>
</template>
<script>
export default{
    name:"Empty",
    data(){
        return{}
    },
    props:{
        emptyType:{
            type:String,
            default:""
        },
        emptyText:{
            type:String,
            default:""
        },
        emptyTips:{
            type:String,
            default:""
        },
        showText:{
            type:Boolean,
            default:true
        },
        showTips:{
            type:Boolean,
            default:true
        },
        showBtn:{
            type:Boolean,
            default:true
        },
        bottomBtn:{
            type:String,
            default:""
        },
        routeName:{
            type:String,
            default:""
        },
        marginTop:{
            type:[Number,String],
            default:0
        }
    },
    computed:{
        marginTopStyle() {
            const mt = this.marginTop;
            if (typeof mt === 'number') {
                return mt + 'px';
            }
            if (typeof mt === 'string') {
                return mt.endsWith('%') ? mt : parseInt(mt) + 'px';
            }
            return '0px';
        },
        emptyImg(){
            switch(this.emptyType){
                case "product":
                    return require("@/assets/images/empty-product-collect.png")
                case 'shop':
                    return require("@/assets/images/empty-shop-follow.png")
                case 'team':
                    return require("@/assets/images/team/empty-team.png")
                case 'folder':
                    return require("@/assets/images/team/empty-folder.png");
                case 'member':
                    return require("@/assets/images/team/empty-member.png");
                case 'shop_product':
                    return require("@/assets/images/shop/empty-shop-product-list.png")
                default:
                    return ''
            }
        }
    },
    mounted(){},
    created(){},
    methods:{
        onBtnClick(){
            if(this.routeName){
                this.$router.push({name:this.routeName})
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.empty-container{
    width:100%;
    max-height:100%;
    background:transparent;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    img{
        width:220px;
        height:170px;
    }
    .empty-text{
        font-size:18px;
        color:#999999;
    }
    .empty-tips{
        color:#b3b3b3;
        font-size:14px;
        margin-top:10px;
    }
    .bottom-btn{
        color:#b3b3b3;
        font-size:14px;
        text-decoration:underline;
        cursor:pointer;
        margin-top:30px;
    }
}
</style>